import { styled } from "styled-components";

export const ContactUsWrapper = styled.div`
  padding: 60px 0;
  @media all and (max-width: 768px) {
    padding: 8.889vw 0;
  }
`;

export const ContactUsWrap = styled.div`
  display: flex;
  gap: 60px;
  .img-area {
    width: 670px;
    > img {
      width: 100%;
    }
    .pc-image {
      height: 900px;
    }
    .mo-image {
      display: none;
    }
  }
  .text-area {
    flex: 1;
    gap: 80px;
    display: flex;
    flex-direction: column;
    .text-item {
      padding-top: 16px;
      border-top: 1px solid #171717;
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding-bottom: 32px;
      span {
        color: #6f6f6f;
        font-size: 16px;
        line-height: 1.5;
      }
      p {
        font-weight: bold;
        color: #242424;
        font-size: 24px;
        line-height: 1.3;
        &.grey-text {
          font-weight: 400;
          font-size: 20px;
          line-height: 1.4;
        }
      }
    }
    .kakao-btn {
      width: 100%;
      height: 68px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      background-color: #171717;
      color: #fee500;
      font-weight: bold;
      font-size: 20px;
      line-height: 1.4;
    }
    .title {
      color: #242424;
      font-weight: 700;
      font-size: 56px;
      line-height: 64px;
      margin-bottom: 32px;
    }
  }
  @media all and (max-width: 1200px) {
    gap: 40px;
    .img-area {
      max-width: 520px;
    }
  }
  @media all and (max-width: 1024px) {
    gap: 30px;
    .img-area {
      max-width: 48.828vw;
    }
    .text-area {
      gap: 65px;
      .text-item {
        span {
          font-size: 14px;
        }
        p {
          font-size: 20px;
          &.grey-text {
            font-size: 18px;
          }
        }
      }
      .kakao-btn {
        height: 60px;
        font-size: 18px;
      }
      .title {
        font-size: 42px;
        line-height: 1.2;
        margin-bottom: 26px;
      }
    }
  }
  @media all and (max-width: 768px) {
    flex-direction: column;
    gap: 5.208vw;
    .img-area {
      max-width: 100%;
      .pc-image {
        /* display: none; */
        height: 65.104vw;
      }
      .mo-image {
        display: block;
        height: 65.104vw;
      }
    }
    .text-area {
      gap: 7.813vw;
      .text-item {
        padding-top: 1.563vw;
        gap: 0.781vw;
        padding-bottom: 3.125vw;
        span {
          font-size: 2.083vw;
        }
        p {
          font-size: 3.646vw;
          &.grey-text {
            font-size: 3.385vw;
          }
        }
      }
      .kakao-btn {
        height: 12.188vw;
        border-radius: 1.563vw;
        font-size: 4.688vw;
      }
      .title {
        font-size: 6.25vw;
        margin-bottom: 3.125vw;
      }
    }
  }
`;
